export const ALL_COLUMNS = [
  { key: "name",            label: "Продукт",                 type: "text" },
  { key: "protein_g",       label: "Белки, г", shortLabel: "Б, г", tooltip: "Белок", type: "number" },
  { key: "fats_g",          label: "Жиры, г", shortLabel: "Ж, г", tooltip: "Жиры", type: "number" },
  { key: "carbs_g",         label: "Углеводы, г", shortLabel: "У, г", tooltip: "Углеводы", type: "number" },
  { key: "energy_kcal",     label: "Энер. ценность, ккал", shortLabel: "ЭЦ, ккал", tooltip: "Энергетическая ценность", type: "number" },
  { key: "fiber_g",         label: "Пищ. волокна, г", shortLabel: "ПВ, г", tooltip: "Пищевые волокна", type: "number" },
  { key: "mds_g",           label: "МДС, г",                  type: "number" },
  { key: "starch_g",        label: "Крахмал, г",              type: "number" },
  { key: "water_g",         label: "Вода, г",                 type: "number" },
  { key: "na_mg",           label: "Na, мг",                  type: "number" },
  { key: "k_mg",            label: "K, мг",                   type: "number" },
  { key: "ca_mg",           label: "Ca, мг",                  type: "number" },
  { key: "mg_mg",           label: "Mg, мг",                  type: "number" },
  { key: "p_mg",            label: "P, мг",                   type: "number" },
  { key: "fe_mg",           label: "Fe, мг",                  type: "number" },
  { key: "ash_g",           label: "Зола, г",                 type: "number" },
  { key: "a_mg",            label: "A, мг", shortLabel: "A, мг", tooltip: "Витамин A", type: "number" },
  { key: "beta_carotene_mg",label: "β-каротин, мг",           type: "number" },
  { key: "b1_mg",           label: "B1, мг", shortLabel: "B1, мг", tooltip: "Витамин B1", type: "number" },
  { key: "b2_mg",           label: "B2, мг", shortLabel: "B2, мг", tooltip: "Витамин B2", type: "number" },
  { key: "pp_mg",           label: "PP, мг", shortLabel: "PP, мг", tooltip: "Витамин PP", type: "number" },
  { key: "c_mg",            label: "C, мг", shortLabel: "C, мг", tooltip: "Витамин C", type: "number" },
  { key: "retinol_index",   label: "Ретиноловый эквив., мг", shortLabel: "РЭ, мг", tooltip: "Ретиноловый эквивалент", type: "number" },
  { key: "tocopherol_index",label: "Токофероловый эквив., мг", shortLabel: "ТЭ, мг", tooltip: "Токофероловый эквивалент", type: "number" },
  { key: "niacin_index",    label: "Ниациновый эквив., мг", shortLabel: "НЭ, мг", tooltip: "Ниациновый эквивалент", type: "number" },
  { key: "nlc_g",           label: "НЖК, г",                  type: "number" },
  { key: "pufa_g",          label: "ПНЖК, г",                 type: "number" },
  { key: "cholesterol_g",   label: "Холестерин, мг",          type: "number" },
  { key: "organic_acids_g", label: "Орг. кислоты, г",         type: "number" },
  { key: "alcohol_pct",     label: "Алк., %",                 type: "number" },
];

export const COLUMN_GROUPS = [
  {
    id: "macros",
    label: "Макронутриенты",
    keys: ["protein_g","fats_g","carbs_g","energy_kcal","fiber_g","mds_g","starch_g","water_g"],
  },
  {
    id: "minerals",
    label: "Минеральные вещества",
    keys: ["na_mg","k_mg","ca_mg","mg_mg","p_mg","fe_mg","ash_g"],
  },
  {
    id: "vitamins",
    label: "Витамины",
    keys: ["a_mg","beta_carotene_mg","b1_mg","b2_mg","pp_mg","c_mg","retinol_index","tocopherol_index","niacin_index"],
  },
  {
    id: "fatty",
    label: "Жирные кислоты",
    keys: ["nlc_g","pufa_g","cholesterol_g"],
  },
  {
    id: "other",
    label: "Другие пищевые вещества",
    keys: ["organic_acids_g","alcohol_pct"],
  },
];
